import { Avatar } from '@chakra-ui/react'
import { HandIcon } from '@heroicons/react/outline'

import { PortfolioLinkType } from 'types'

import { ReactComponent as AxosLogo } from 'assets/icons/AXOS.svg'
import { ReactComponent as FidelityLogo } from 'assets/icons/FIDELITY.svg'
import { ReactComponent as PaveSecuritiesLogo } from 'assets/icons/PAVE.svg'
import { ReactComponent as SchwabLogo } from 'assets/icons/SCHWAB.svg'
import { COLOR } from 'designSystem/foundations/constants/color'

type Props = {
  linkType: string
}

export default function BrokerIcon({ linkType }: Props) {
  let icon = null

  switch (linkType) {
    case PortfolioLinkType.PaveSecurities:
      icon = <PaveSecuritiesLogo width={20} height={20} />
      break
    case PortfolioLinkType.CharlesSchwab:
      icon = <SchwabLogo width={20} height={20} />
      break
    case PortfolioLinkType.Fidelity:
      icon = <FidelityLogo width={20} height={20} />
      break
    case PortfolioLinkType.Axos:
      icon = <AxosLogo width={20} height={20} />
      break
    default:
      // Replace with a Manual Logo SVG
      icon = <HandIcon width={20} height={20} />
      break
  }

  if (PortfolioLinkType.None) {
    return icon
  } else {
    return <Avatar backgroundColor={COLOR.white} icon={icon} size="xs" />
  }
}
